export default __webpack_public_path__ + "static/media/Transparent.1ff0412a.svg";